<template>
  <div class="admin-announce-page anim-fade-in-up">
    <!-- 筛选 + 操作栏 -->
    <div class="content-card filter-bar">
      <div class="filter-left">
        <el-input v-model="keyword" placeholder="请输入公告标题查询" size="small" style="width: 200px;" clearable @keyup.enter.native="handleSearch" />
        <el-button size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="small" @click="handleReset">重置</el-button>
      </div>
      <div class="filter-right">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate">新增公告</el-button>
      </div>
    </div>

    <!-- 数据表 -->
    <div class="content-card" style="padding: 4px;">
      <el-table :data="tableData" border stripe v-loading="loading" size="small" style="width: 100%">
        <el-table-column prop="title" label="标题" min-width="160" show-overflow-tooltip />
        <el-table-column label="内容" min-width="200" show-overflow-tooltip>
          <template slot-scope="{row}"><span class="content-preview">{{ (row.content || '').substring(0, 80) }}{{ (row.content || '').length > 80 ? '...' : '' }}</span></template>
        </el-table-column>
        <el-table-column prop="publisher" label="发布人" min-width="90" />
        <el-table-column label="发布时间" min-width="140">
          <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ').substring(0,16) : '' }}</template>
        </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button type="info" icon="el-icon-view" size="mini" circle @click="openDetail(row)" />
            <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="openEdit(row)" />
            <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="total > 0" class="pagination-wrap">
      <el-pagination
        background
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @current-change="v => { page = v; fetchList(); }"
      />
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="editMode ? '编辑公告' : '新增公告'" width="600px" append-to-body :close-on-click-modal="false">
      <el-form ref="announceFormRef" :model="form" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入公告标题" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="6" maxlength="5000" show-word-limit placeholder="请输入公告内容" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>

    <!-- 预览对话框 -->
    <el-dialog :visible.sync="detailVisible" :title="detailItem.title" width="600px" append-to-body :close-on-click-modal="false">
      <p style="color: var(--text-secondary); white-space: pre-wrap; line-height: 1.8;">{{ detailItem.content }}</p>
      <div slot="footer" style="font-size: 0.8rem; color: var(--text-muted);">
        {{ detailItem.publisher }} · {{ detailItem.createTime ? detailItem.createTime.replace('T',' ').substring(0,16) : '' }}
      </div>
    </el-dialog>

  </div>
</template>

<style scoped>
.page-title {
  font-family: var(--font-display);
  font-size: 1.5rem; font-weight: 500;
  color: var(--text-primary); margin: 0 0 18px; letter-spacing: 0.04em;
}

.content-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.filter-bar {
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 20px; margin-bottom: 16px;
  flex-wrap: wrap; gap: 10px;
}
.filter-left { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.filter-right { display: flex; gap: 10px; align-items: center; flex-shrink: 0; }
.content-preview { color: var(--text-muted); }
.pagination-wrap { margin-top: 18px; text-align: right; }
</style>

<script>
export default {
  data() {
    return {
      keyword: '', page: 1, pageSize: 10, tableData: [], total: 0, loading: false,
      dialogVisible: false, editMode: false, editId: null, submitting: false,
      form: { title: '', content: '' },
      detailVisible: false, detailItem: {}
    }
  },
  created() { this.fetchList(); },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const resp = await this.$axios.get('/adm/announcement/list', { params: { keyword: this.keyword, page: this.page, pageSize: this.pageSize } });
        if (resp.data.code === 0) { const d = resp.data.data; this.tableData = d.list || []; this.total = d.total || 0; }
      } catch (e) { console.error(e); } finally { this.loading = false; }
    },
    handleSearch() { this.page = 1; this.fetchList(); },
    handleReset() { this.keyword = ''; this.page = 1; this.fetchList(); },
    openCreate() { this.editMode = false; this.editId = null; this.form = { title: '', content: '' }; this.dialogVisible = true; },
    openEdit(row) { this.editMode = true; this.editId = row.id; this.form = { title: row.title, content: row.content }; this.dialogVisible = true; },
    openDetail(row) { this.detailItem = row; this.detailVisible = true; },
    async handleSubmit() {
      if (!this.form.title.trim() || !this.form.content.trim()) { this.$message.warning('标题和内容不能为空'); return; }
      this.submitting = true;
      try {
        const url = this.editMode ? `/adm/announcement/${this.editId}` : '/adm/announcement';
        const method = this.editMode ? 'put' : 'post';
        const resp = await this.$axios[method](url, this.form);
        if (resp.data.code === 0) { this.$message.success(this.editMode ? '更新成功' : '发布成功'); this.dialogVisible = false; this.fetchList(); }
        else { this.$message.error(resp.data.msg || '操作失败'); }
      } catch (e) { this.$message.error('操作失败'); } finally { this.submitting = false; }
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确定删除公告「${row.title}」吗？`, '删除公告', { type: 'warning' });
        const resp = await this.$axios.delete(`/adm/announcement/${row.id}`);
        if (resp.data.code === 0) { this.$message.success('已删除'); this.fetchList(); }
        else { this.$message.error(resp.data.msg || '删除失败'); }
      } catch (e) { if (e !== 'cancel') { this.$message.error('删除失败'); } }
    }
  }
}
</script>
